<template>
  <div class="relative flex flex-col lg:ml-[160px] md:ml-[80px] ml-[20px] lg:mt-[100px] mt-[80px]">
    <div class="md:block hidden absolute md:w-20 lg:right-0 md:right-[84px] z-20 md:h-[328px]" style="bottom:22px;background: linear-gradient(to right, rgba(248,249,250, 0), rgba(248,249,250, 0.8) 70%,  #f8f9fa 100%);"
    ></div>
    <div class="flex flex-col lg:gap-8 gap-4">
      <div class="text-brand-orange md:text-[32px] text-[16px] capitalize">ATMOSFÉRA</div>
      <div class=" mr-[90px] flex flex-row items-center justify-between">
        <p class="text-black md:text-[56px] text-[28px] font-extrabold" style="line-height: 115%">
          Jak to na Shopcampu vypadá?
        </p>
        <Dropdown @selection-changed="changeSelectedYear" class="mr-[5%] md:block hidden"/>
      </div>
      <p class="md:text-[18px] text-[16px] md:mr-[90px] lg:mr-0 font-medium">Nasajte atmosféru a knowhow minulých ročníků ze záznamů
        přednášek, sestřihů a fotek.</p>
      <Dropdown @selection-changed="changeSelectedYear" class="max-w-[160px] block md:hidden"/>
    </div>
    <Carousel>
      <template v-slot:default>
        <CarouselItem
          v-if="selectedYear === 2024"
          href="https://drive.google.com/drive/folders/1Cx2hqFt8vqSGlwV_btxhJ6PENlmF18nt"
          class="inline-flex pb-4"
          title="Fotky z Shopcampu 2024"
          author="Album"
        >
          <img
            class="h-[156px] md:h-[220px] object-cover w-full rounded-t-[20px]"
            src="/assets/carousel/2019/cover-24.jpg"
            alt="Fotoalbum Shopcamp 2024 - cover photo"
          />
        </CarouselItem>
        <CarouselItem
          v-if="selectedYear === 2023"
          href="https://www.facebook.com/media/set/?set=a.686255046870495"
          class="inline-flex pb-4"
          title="Fotky z Shopcampu 2023"
          author="Album"
        >
          <img
            class="h-[156px] md:h-[220px] object-cover w-full rounded-t-[20px]"
            src="/assets/carousel/2019/cover-23.jpeg"
            alt="Fotoalbum Shopcamp 2023 - cover photo"
          />
        </CarouselItem>
        <CarouselItem
          v-if="selectedYear === 2022"
          href="https://www.facebook.com/media/set/?set=a.5468360573248254&type=3"
          class="inline-flex pb-4"
          title="Fotky z Shopcampu 2022"
          author="Album"
        >
          <img
            class="h-[156px] md:h-[220px] object-cover w-full rounded-t-[20px]"
            src="/assets/carousel/2019/fb-fotky-cover.jpeg"
            alt="Fotoalbum Shopcamp 2022 - cover photo"
          />
        </CarouselItem>
        <CarouselItem
          v-if="selectedYear === 2021"
          href="https://www.facebook.com/media/set/?set=a.4320791118005211&type=3"
          class="inline-flex pb-4"
          title="Fotky z Shopcampu 2021"
          author="Album"
        >
          <img
            class="h-[156px] md:h-[220px] object-cover w-full rounded-t-[20px]"
            src="/assets/carousel/2019/fb-fotky-cover.jpeg"
            alt="Fotoalbum Shopcamp 2021 - cover photo"
          />
        </CarouselItem>
        <CarouselItem
          v-if="selectedYear === 2020"
          href="https://www.facebook.com/media/set/?set=a.3312100078874325&type=3"
          class="inline-flex pb-4"
          title="Fotky z Shopcampu 2020"
          author="Album"
        >
          <div class="flex flex-wrap justify-center items-center">

            <img
              class="w-[80px] hidden md:block h-[80px] m-2"
              v-for="i in 8"
              :key="i"
              :src="'/assets/carousel/carousel-1/image' + i + '.png'"
              alt=""
            />
            <img
              class="w-[60px] md:hidden h-[60px] m-2"
              v-for="i in 6"
              :key="i"
              :src="'/assets/carousel/carousel-1/image' + i + '.png'"
              alt=""
            />
          </div>
        </CarouselItem>
        <CarouselItem
          v-if="selectedYear === 2019"
          href="https://www.facebook.com/media/set/?set=a.2422761397808202&type=3"
          class="inline-flex pb-4"
          title="Fotky z Shopcampu 2019"
          author="Album"
        >
          <img
            class="h-[156px] md:h-[220px] object-cover w-full rounded-t-[20px]"
            src="/assets/carousel/2019/fb-fotky-cover.jpeg"
            alt="Fotoalbum Shopcamp 2019 - cover photo"
          />
        </CarouselItem>
        <CarouselItem
          v-if="selectedYear === 2018"
          href="https://www.facebook.com/media/set/?vanity=shopcampcz&set=a.1859134560837558"
          class="inline-flex pb-4"
          title="Fotky z Shopcampu 2018"
          author="Album"
        >
          <img
            class="h-[156px] md:h-[220px] object-cover w-full rounded-t-[20px]"
            src="/assets/carousel/2019/fb-fotky-cover.jpeg"
            alt="Fotoalbum Shopcamp 2018 - cover photo"
          />
        </CarouselItem>
        <CarouselItem
          v-if="selectedYear === 2017"
          href="https://www.facebook.com/media/set/?set=a.1453238764760475&type=3"
          class="inline-flex pb-4"
          title="Fotky z Shopcampu 2017"
          author="Album"
        >
          <img
            class="h-[156px] md:h-[220px] object-cover w-full rounded-t-[20px]"
            src="/assets/carousel/2019/fb-fotky-cover.jpeg"
            alt="Fotoalbum Shopcamp 2017 - cover photo"
          />
        </CarouselItem>
        <CarouselItem
          v-if="selectedYear === 2016"
          href="https://www.facebook.com/media/set/?set=a.1097147810369574&type=3"
          class="inline-flex pb-4"
          title="Fotky z Shopcampu 2016"
          author="Album"
        >
          <img
            class="h-[156px] md:h-[220px] object-cover w-full rounded-t-[20px]"
            src="/assets/carousel/2019/fb-fotky-cover.jpeg"
            alt="Fotoalbum Shopcamp 2016 - cover photo"
          />
        </CarouselItem>

        <CarouselItem
          v-if="selectedYear === 2015"
          href="https://www.facebook.com/media/set/?set=a.895661823851508&type=3"
          class="inline-flex pb-4"
          title="Fotky z Shopcampu 2015"
          author="Album"
        >
          <img
            class="h-[156px] md:h-[220px] object-cover w-full rounded-t-[20px]"
            src="/assets/carousel/2019/fb-fotky-cover.jpeg"
            alt="Fotoalbum Shopcamp 2015 - cover photo"
          />
        </CarouselItem>

        <CarouselItem
          v-for="(item, i) in currentYearData"
          :key="i"
          class="inline-flex pb-2"
          :videoId="item.videoId"
          :isVideo="item.videoId !== undefined"
          :title="item.title"
          :author="item.author"
        >
        </CarouselItem>


      </template>
    </Carousel>
  </div>
</template>

<script>
import Carousel from "../Carousel/Carousel.vue";
import CarouselItem from "./CarouselItem.vue";
import Dropdown from "./Dropdown.vue";
import {useWindowSize} from "@vueuse/core";
import {computed} from "vue";

const data2024 = [
  {
    videoId: 'yJBmJAF960o',
    title: 'Aftermovie',
    author: 'Shopcamp 2024'
  },
  {
    videoId: 'Udh1kjpyBkY',
    title: 'Jak je důležité míti Františka',
    author: 'Martin Kudrna & Jan Coufal'
  },
  {
    videoId: 'NfqdfzVEs1U',
    title: 'Jiný pohled – velký potenciál',
    author: 'Jitka Dvořáková'
  },
  {
    videoId: '_Ga8hmH4x5g',
    title: 'Co chce váš zákazník a jak spolupracovat s dodavateli, aby to bylo win-win-win',
    author: 'Jan Jirsa'
  },
  {
    videoId: 'gZwq82RL_bw',
    title: 'Analýza objednávek 200 e-shopů z pohledu UX',
    author: 'Ondřej Ilinčev & Petr Krakowczyk'
  },
  {
    videoId: 'ZNkbZgd9oQI',
    title: 'Jak Vuch v roce 2023 maximalizoval tržby z e-mailingu',
    author: 'Radka Breitzetelová & Aneta Abelová'
  },
  {
    videoId: '4aMF50LSbxo',
    title: 'Cesta k privátnej značke',
    author: 'Matej Kulich'
  },
  {
    videoId: 'EVBf3HldPhk',
    title: 'Největší chyby na CZ/SK e-shopech',
    author: 'Jan Kvasnička'
  },
  {
    videoId: 'F2AjcDqLMM4',
    title: 'Jediná správná strategie je nevěra!',
    author: 'Daniel Kvíčala & Radim Uher'
  },
  {
    videoId: 'aN8RnAZ5_3c',
    title: 'Papír, tužka, čtečka: Jak jsme zautomatizovali expedici v Ovečkárně',
    author: 'Ondřej Machala'
  },
  {
    videoId: '46mmajCBl9g',
    title: 'Úspěšný e-shop bez zbytečných výdajů na reklamu',
    author: 'Petra Pacáková'
  },
  {
    videoId: '_8VVa7En544',
    title: 'E-shop vs. psychologie :brain:',
    author: ' Kamil Pavlíček'
  },
  {
    videoId: '3Cyz4Opb8Hw',
    title: 'Lepší zákaznickou zkušeností k ziskovějšímu e-shopu',
    author: 'Lukáš Pítra'
  },
  {
    videoId: '1t046sIdfcs',
    title: 'Jak zvýšit konverzní poměr e-shopu díky AI :chart_with_upwards_trend:',
    author: 'Vladimír Šandera'
  },
  {
    videoId: 'PwxGV7Q83z0',
    title: 'Klíč k úspěchu: Analýza 100+ úspěšných e-shopů. Co dělají jinak?',
    author: 'Filip Svárovský'
  },
]
const data2023 = [
  {
    videoId: '1RXNyikuGOA',
    title: 'Videosestřih ze dne',
    author: 'Shopcamp 2023'
  },
  {
    videoId: 'OXPhCL9X6HQ',
    title: 'To nejlepší z reklamy na Facebooku v roce 2023',
    author: 'Petr Handlíř'
  },
  {
    videoId: 'DCWzXe0drqU',
    title: 'Expanze do celé Evropy - v pár lidech a ze Vsetína',
    author: 'Martina Baletková'
  },
  {
    videoId: '2X2MLfm3c0c',
    title: 'Case-study Bloom Robbins: 3 klíčové faktory raketového růstu',
    author: 'Adam Cvik'
  },
  {
    videoId: 'H6hXZChxcBk',
    title: 'Jaké SEO AI zabije a jaké posílí',
    author: 'Pavel Ungr'
  },
  {
    videoId: 'DDYdMZYq3oc',
    title: 'Jak zvyšovat konverzní poměr e-shopu pomocí storytellingu produktu',
    author: 'Jan Kvasnička'
  },
  {
    videoId: 'dIIjp2-CAbo',
    title: 'Zahraniční expanze jako driver růstu e-shopu – 20 zemí za 10 měsíců',
    author: 'Antonín Štětina'
  },
  {
    videoId: 'nHrBR6QgSgI',
    title: '12 nejčastějších chyb v e-mailingu a tipy, jak se jim vyvarovat',
    author: 'Markéta Kryštůfková'
  },
  {
    videoId: 'V4s3t4jxlWg',
    title: 'Finanční řízení - na 100 % otevřeně, prakticky (a zábavně)',
    author: 'Ruslan Skopal'
  },
  {
    videoId: 'M50vV-Sektc',
    title: 'Technologická příprava na růst (i pro netechnické publikum)',
    author: 'Ondrej Proksa'
  },
  {
    videoId: 'hDaMPFwB3B4',
    title: 'Co chcete měřit ve svých GA4',
    author: 'Pavel Šabatka'
  },
  {
    videoId: 'EJ1YWbpEhDM',
    title: 'Rozhovor: Strategie, smysl v podnikání a skvělé zákaznické a zaměstnancké zkušenosti',
    author: 'Michal Meško'
  },
  {
    videoId: '9DKaw3_Oor8',
    title: 'BRENO – z marketingového sklepa na vrchol, za 4 roky tržby +1200 %',
    author: 'Jakub Klaus & Pham Bich Ngoc'
  },
  {
    videoId: 'V5J25jtJIhs',
    title: 'Co z UX táhne lidi na e-shopech v roce 2023',
    author: 'Marek Čevelíček'
  },
  {
    videoId: 'd0f9t-c0EYQ',
    title: 'Jak s AI chatbotem personalizovaně oslovovat návštěvníky a více prodávat',
    author: 'Vladimír Šandera'
  },
]

const data2022 = [
  {
    videoId: 'a8TJGUyeLjY',
    title: 'Videosestřih ze dne',
    author: 'Shopcamp 2022'
  },
  {
    videoId: 'TBc6IXcCIqE',
    title: 'Jak převést potřeby, obavy a touhy vašich zákazníků ve funkční byznys',
    author: 'Jan Kvasnička'
  },
  {
    videoId: 'LwgMTrChTO4',
    title: 'To nejlepší z reklamy na Facebooku v roce 2022',
    author: 'Petr Handlíř'
  },
  {
    videoId: 'uqKz_SnJ8Dc',
    title: 'Jak na lidi v e-commerce',
    author: 'Marek Liška'
  },
  {
    videoId: 'VnKV-ncP2WI',
    title: 'Konec online reklamy jak ji známe',
    author: 'Šárka Vokounová'
  },
  {
    videoId: 'o4p4EIScYTU',
    title: 'D2C aneb trend, který má výsledky',
    author: 'Radek Hudák'
  },
  {
    videoId: 'kkt8ltPvDOQ',
    title: 'Jak zvýšit počet objednávek pomocí copywritingu?',
    author: 'Michal Husák'
  },
  {
    videoId: 'WomPs3ks85w',
    title: 'Jak kombinací live chatu a chatbota zvýšit hodnotu objednávky',
    author: 'Daniel Višňák'
  },
  {
    videoId: '2xVMNXLhL1w',
    title: '7 tipů z praxe, jak se nenechat napálit IT dodavateli ve výběrových řízeních',
    author: 'Michal Dugáček'
  },
  {
    videoId: 'MKOwOlZu3ew',
    title: 'Jak s Heurekou vydělat co nejvíce',
    author: 'Honza Mayer'
  },
  {
    videoId: 'XQpyvMiy_MY',
    title: 'Jak jsme zvýšili tržby meziročně o 600 %?',
    author: 'Veronika Adams'
  },
  {
    videoId: '49rYg4Hi17M',
    title: 'Jak zšestinásobit výkonnost e-mailové automatizace',
    author: 'Pavel Bulowski'
  },
  {
    videoId: 'Wm67fIhTzgc',
    title: 'Jak se nepropadnout v SEO ani při velkých změnách na e-shopu',
    author: 'Lukáš Fibiger'
  },
  {
    videoId: 'Ge6CBwNy-08',
    title: 'Logistika v e-commerce (rozhovor)',
    author: 'Peter Árva'
  },
  {
    videoId: 'XQQmpPiaN8M',
    title: 'Knihy, příběhy a my, kteří je prodáváme',
    author: 'Adam Pýcha'
  },
  {
    videoId: 'ZGVRAJ8HN9k',
    title: 'Marketplace - dobrý sluha, ale zlý pán',
    author: 'David Cikánek'
  },
  {
    videoId: 'XtL_kBqoXJ0',
    title: 'Rozhovor se zakladatelem Ovečkárny o řízení e-shopu',
    author: 'Martin Bernátek'
  },
  {
    videoId: 'msSD9A4rBwk',
    title: 'Jak budovat brand, když je „všechno velký špatný”?',
    author: 'Marek Vaniš a Radka Kazdová'
  },
]

const data2021 = [
  {
    videoId: 'VaTD9nUoTJI',
    title: 'Videosestřih ze dne',
    author: 'Shopcamp 2021'
  },
  {
    videoId: 'kkgy90wzIbM',
    title: 'Bez dat se dnes neobejdete, pokud chcete, aby vám e-shop dlouho vydělával',
    author: 'Michal Buzek'
  },
  {
    videoId: 'YlzbR7aPGqY',
    title: 'Problém druhé objednávky',
    author: 'Radek Hrachovec'
  },
  {
    videoId: 'Kb_2dpabxs8',
    title: 'To nejlepší z reklamy na Facebooku',
    author: 'Petr Handlíř'
  },
  {
    videoId: '14etxfYVcGc',
    title: 'Zjednodušením objednávkového procesu k vyšším konverzím',
    author: 'Petr Svoboda'
  },
  {
    videoId: 'bAcV-sl7zGY',
    title: 'Tři obří e-commerce příležitosti, které urychlil Covid',
    author: 'Radek Hudák'
  },
  {
    videoId: '​​3GH94V869Yk',
    title: '10 tipů z našeho růstu z 6 na 300 milionů za 5 let',
    author: 'Dominik Píchal'
  },
  {
    videoId: 'W6td2D8lM78',
    title: 'Čísla v e-mailingu (ta důležitá a akceschopná)',
    author: 'Jakub Čižmař'
  },
  {
    videoId: 'XY6FXpBLAJA',
    title: 'Jak udělat dobrý první dojem',
    author: 'Ondřej Ilinčev'
  },
  {
    videoId: 'cV-5CUB1WhE',
    title: 'Google Analytics 4 pro e-shopaře',
    author: 'Jan Tichý'
  },
  {
    videoId: 'FXsWP8DgvmY',
    title: 'Nejčastější chyby v produktových obrázcích',
    author: 'Marek Daňko'
  },
  {
    videoId: 'HOpjFpt74Wg',
    title: 'Finanční řízení pro e-shopy',
    author: 'Pavel Jaroš'
  },
  {
    videoId: '7Dkajk1J9kk',
    title: 'Jak se ptát zákazníků? 8 rozhovorů odhalí 80% problémů',
    author: 'Romana Mazalová'
  },
  {
    videoId: '574NXhT9Jtg',
    title: 'Má smysl tvořit na e-shopech obsah?',
    author: 'Jan Novák'
  },
]

const data2020 = [
  {
    videoId: 'iooPxp0vdmM',
    title: 'Videosestřih ze dne',
    author: 'Shopcamp 2020'
  },
  {
    videoId: 'EbmVG_SfRqY',
    title: 'Jak se změnily zvyklosti v nákupním chování a přístup e-shopů následkem koronakrize',
    author: 'Michal Vodák'
  },
  {
    videoId: 'ZEgwDyuEUxA',
    title: 'Zdravá nespokojenost, selský rozum a kupecké počty',
    author: 'Petr Bena'
  },
  {
    videoId: 'tv4ccs2A3K4',
    title: 'Jak jsem pomohl Vaskám 10 násobně zvýšit investice do reklamy na Facebooku — ziskově',
    author: 'Petr Handlíř'
  },
  {
    videoId: 'WjjA4bmoM0U',
    title: 'Co e-shopům v SEO utíká? Trochu lásky a péče!',
    author: 'Pavel Ungr'
  },
  {
    videoId: 'llybu-VKewo',
    title: 'UX faily na e-shopech a jak je nedělat',
    author: 'Marek Čevelíček'
  },
  {
    videoId: 'TvqpHNAqN9Y',
    title: 'Čísla neříkají celý příběh, pochopte své zákazníky díky online focus group',
    author: 'Matez Jindra, Honza Páv'
  },
  {
    videoId: 'vVQO3Tzi8_0',
    title: 'Na čem v řízení lidí skutečně záleží',
    author: 'Stanislav Háša'
  },
  {
    videoId: 'eL7rowu1zZk',
    title: 'Different ZOOT',
    author: 'Milan Polák'
  },
  {
    videoId: '93Ch6PNDEdQ',
    title: 'Co funguje v optimalizaci konverzí',
    author: 'Ondřej Ilinčev'
  },
  {
    videoId: 'tHtEi9QjZZk',
    title: 'Rok 2020 v e-commerce, jaké jsou trendy a na co nesmí e-shopař zapomenout',
    author: 'Radek Hudák'
  },
  {
    videoId: 'ucNz_ITclAw',
    title: '11 největších fuckupů v PPC reklamě a 11 snadných hacků, jak vydělat ranec',
    author: 'Ladislav Vitouš'
  },
  {
    videoId: 'q1aazLI2GTk',
    title: '2020: Rok marketplaces',
    author: 'David Cikánek'
  },
]

const data2019 = [
  {
    videoId: '-1im3fE_nAc',
    title: 'Shopcamp 2019',
    author: 'Videosestřih ze dne'
  },
  {
    videoId: 'MnoCDmFVXqM',
    title: 'Omnichannel a atribuce v praxi',
    author: 'Filip Černý'
  },
  {
    videoId: 'TEZQMUTwmw8',
    title: 'Migrace platformy a revize strategie Aukra',
    author: 'Lumír Kunz'
  },
  {
    videoId: 'ogXejsx5vCg',
    title: '5 nejčastějších chyb ve finančním řízení e-shopu',
    author: 'Michal Koubek'
  },
  {
    videoId: 'uwPYzLZCzNo',
    title: 'Strategie expanze e-shopu do zahraničí',
    author: 'Milan Fiala'
  },
  {
    videoId: 'A69kCuZBTyU',
    title: 'Zlepšujeme web - Použitelnost a přesvědčivost',
    author: 'Marek Čevelíček'
  },
  {
    videoId: 'BSpdnv9k9pM',
    title: 'Dělám správná rozhodnutí v cenotvorbě? Jak se k ní postavit, když mám e-shop?',
    author: 'Honza Mayer'
  },
  {
    videoId: 'BSpdnv9k9pM',
    title: 'Dělám správná rozhodnutí v cenotvorbě? Jak se k ní postavit, když mám e-shop?',
    author: 'Honza Mayer'
  },
  {
    videoId: 'LfxHFDS2_-E',
    title: 'Marketing e-shopů, anebo co dělat, když vyhledávání nestačí',
    author: 'Radek Hudák & David Herold'
  },
  {
    videoId: '-oBsy7x-1Dc',
    title: 'Právní minimum pro e-shopy',
    author: 'Petra Stupková'
  },
  {
    videoId: 'mUBI9fSdAA8',
    title: 'Optimalizace srovnávačů zboží',
    author: 'Adam Funiok'
  },
  {
    videoId: 'TwgcwHYbMlI',
    title: 'CS: Typy reaktivačních kampaních v praxi',
    author: 'Jakub Malý'
  },
  {
    videoId: 'AGmXs_7tkk8',
    title: 'CS: Jak za pakatel zpropagovat e-shop ve videích influencerů na YouTube',
    author: 'Jakub Straka'
  },
  {
    videoId: 'ywPcB0Z-Dko',
    title: 'CS: 90% Open Rate obchodního sdělení za menší cenu než e-mailing. Jak na to?',
    author: 'Adam Kolek'
  },
  {
    videoId: '9WiG_Hz6eak',
    title: 'Jak zvýšit výkon e-shopu krok za krokem',
    author: 'Lukáš Dubina'
  },
]


const data2018 = [
  {
    videoId: 'sPEHb8OUU_Y',
    title: 'Shopcamp 2018',
    author: 'Videosestřih ze dne'
  },
  {
    videoId: 'b8OKc2k6nCg',
    title: 'Připravte se na růst (nejen) vašeho e-shopu',
    author: 'Lukáš Havlásek'
  },
  // {
  //   videoId: '1WzBKJWgeLI',
  //   title: 'Automatizovaný bidding: průšvihář nebo šikovný pomocník?',
  //   author: 'Petra Mikulášková'
  // },
  {
    videoId: 'D8fwLVLcwdk',
    title: '20 let v e-commerce a logistice',
    author: 'Martin Hausenblas'
  },
  {
    videoId: 'Qq1WXRy2XZ4',
    title: 'Nejčastější GDPR chyby v online podnikání',
    author: 'Petra Stupková'
  },
  {
    videoId: 'FvKhOs01jE0',
    title: 'CS: Globální e-commerce: jak z Česka dobýt celý svět',
    author: 'V. M. Rechová, P. Babinec'
  },
  {
    videoId: 'ricAmnPIOdo',
    title: 'Tvrdá marketingová a obchodní data 200 e-shopů',
    author: 'Pavel Šíma'
  },
  {
    videoId: 'TuesXRLlPvI',
    title: 'Automatizovaný bidding: průšvihář nebo šikovný pomocník?',
    author: 'Petra Mikulášková'
  },
  {
    videoId: '-VapQq_3f5c',
    title: 'Najděte procesy, které vás brzdí a stojí moc peněz!',
    author: 'Jan Kalianko'
  },
  {
    videoId: 'GuWvsQ75fcg',
    title: 'Bolesti i radosti českých e-shopů',
    author: 'Ondřej Klega'
  },
  {
    videoId: 'TKkcmV5HhTU',
    title: 'Tipy pro efektivní využití Google Analytics',
    author: 'Stanislav Vasko'
  },
  {
    videoId: 'X2pKL5sKTzM',
    title: '250% nárůst měsíčních tržeb po půl roce spolupráce',
    author: 'Pavel Tlapák'
  },
  {
    videoId: 'O_4AAL0rm4A',
    title: 'Za lepší weby! Nejčastější faily na webech, jak je odhalit a odstranit',
    author: 'David Mareček'
  },
  {
    videoId: 'ZVBTr5atC6w',
    title: 'Z nuly na 100. Jak se dělá e-shopová speciálka',
    author: 'Lada Pěgřimková'
  },
  {
    videoId: 'UYSK-A_Cb4U',
    title: 'Data, která na e-shopu máte, mají cenu zlata',
    author: 'Radek Hudák'
  },
  {
    videoId: 'FEmsQdAxxgM',
    title: 'Email marketing pro malé a střední eshopy',
    author: 'Petr Havlíček'
  },
  {
    videoId: 'taIunMaNJ9o',
    title: 'Košík sem, košík tam',
    author: 'Ondřej Ilinčev'
  },
]

const data2017 = [
  {
    videoId: 'YTPEhyplnDM',
    title: 'Shopcamp 2017',
    author: 'Videosestřih ze dne'
  },
  {
    videoId: 'dIUx36WAAT8',
    title: 'Data-driven řízení firmy s Power BI v praxi: zkušenosti a (finanční) přínosy',
    author: 'Pavel Jaroš'
  },
  {
    videoId: 'BAiOLgYRTsc',
    title: 'Automatizace jsou více než jen přání k svátku. Úvod do multichannel marketingu',
    author: 'Jan Tlapák'
  },
  {
    videoId: 'HZ6bDedpHiw',
    title: 'CS: Co nás 5 milionů plateb naučilo o tom, jak získat víc dokončených objednávek?',
    author: 'Jan Vodička'
  },
  {
    videoId: 'xly_GrFrOYk',
    title: 'Technologie a rychlost inovací jako hlavní pilíř úspěchu e-shopů',
    author: 'Petr Svoboda'
  },
  {
    videoId: 'VNoY7q7gbGE',
    title: 'Jak je důležité PROČ v networkingu?',
    author: 'Jindra Brousková'
  },
  {
    videoId: 'YyV--Jb8BEU',
    title: 'Co se stane, když přehlédneme emoce v obchodní komunikaci',
    author: 'Jindra Brousková'
  },
  {
    videoId: 'OrkUH9V_Kfo',
    title: 'Právní ochrana podnikání',
    author: 'Ondřej Preuss'
  },
  {
    videoId: 'wc99l-qqQG0',
    title: 'Éra marketplace. Hrozba nebo příležitost pro eshopy?',
    author: 'Václav Liška'
  },
  {
    videoId: '0wJA8s76nwY',
    title: 'Z korun miliony',
    author: 'Petra Plemlová'
  },
  {
    videoId: 'ee4wHxZwrUU',
    title: 'CS: Vliv dobírky na prodej ve střední a východní Evropě',
    author: 'Karel Lyčka'
  },
  {
    videoId: 'Zfbr0lJVIxw',
    title: 'CS: Kokosy v přechodu',
    author: 'Barbora Nalepová'
  },
  {
    videoId: 'accknFMqAv0',
    title: 'Konec intuicím – začněte konečně tvořit obsah na základě dat!',
    author: 'Marie Štouračová'
  },
  {
    videoId: 'XO76Mh7c0qM',
    title: 'Konec doby zbožákové?',
    author: 'Vladimír Přichystal'
  },
  {
    videoId: 'XV0Z_ZO3bps',
    title: 'Objevte v PPC nevyužitý potenciál',
    author: 'Jiří Novák'
  },
  {
    videoId: '01Vl9xtQkfM',
    title: 'CS: Vliv brandu na prodeje a expanzi',
    author: 'Patrik Babinec'
  },
  {
    videoId: 'dbBEv4rJoQ0',
    title: 'Omnichannel strategie pro komunikaci se zákazníkem 2020',
    author: 'Michal Hanáček'
  },
  {
    videoId: 'Zo_YfxaTlTM',
    title: 'Jak se jako e-shopař vzdělávat?',
    author: 'Jan Kalianko'
  },
  {
    videoId: 'VSzrD8GOFQo',
    title: 'CS: Nové komunikační kanály jako nástroj pro zvýšení efektivity',
    author: 'Pavel Mikulka'
  },
]


const data2016 = [
  {
    videoId: 'gPDfXE0-nlA',
    title: 'Shopcamp 2016',
    author: 'Videosestřih ze dne'
  },
  {
    videoId: 'yklTlTid-hg',
    title: 'Jak vytěžit co nejvíce z poobjednávkového procesu',
    author: 'Jiří Maňásek'
  },
  {
    videoId: 'Oj8pvblDKCo',
    title: 'Jak připravit PPC kampaně na vánoční sezónu',
    author: 'František Štrupl'
  },
  {
    videoId: 'Oj8pvblDKCo',
    title: 'Jak připravit PPC kampaně na vánoční sezónu',
    author: 'František Štrupl'
  },
  {
    videoId: 'NPSWH855wf8',
    title: 'Personalizovaný web 3.0 – stránky, které používají mozek',
    author: 'Jan Černý'
  },
  {
    videoId: 'P26RPVJaoCk',
    title: 'Jak uřídit prodeje na více zahraničních trzích',
    author: 'Simona Kijonková a Eva Kupcová'
  },
  {
    videoId: 'WvkkLXtXJBo',
    title: 'Proč si zákazníci skutečně kupují konkrétní výrobky a jak toho využít ve svém e-shopu',
    author: 'Jirka Chomát'
  },
  {
    videoId: 'ytxEZQ5oZNY',
    title: '#UX a #CRO chyby, které ostatní udělali za vás, aneb jak na to u e-shou správně',
    author: 'Jan Kalianko'
  },
  {
    videoId: '69nHcFeE9r8',
    title: 'Agentura vs. In-house team v online marketingu',
    author: 'Honza Randus'
  },
  {
    videoId: 'r-p_kmGoBjw',
    title: 'Vybrané e-shopářské vychytávky z Google Analytics',
    author: 'Romana Velflová a Tomáš Kumsta'
  },
  {
    videoId: 'jE-OLHsAmXM',
    title: 'Mergado: novinky pro Vánoční prodejní sezónu 2016',
    author: 'Michal Janík'
  },
  {
    videoId: 'Z189ogdH1B8',
    title: '6 jednoduchých akčních kroků k efektivnímu e-mail marketingu',
    author: 'Jakub Čižmař'
  },
  {
    videoId: 'tjE48CCXkSg',
    title: 'Jste připraveni na expanzi do zahraničí?',
    author: 'Jan Poštulka'
  },
  {
    videoId: 'PPqV7jJfz_w',
    title: 'Case-study: Jak vytěžit z reklamy na Facebooku maximum?',
    author: 'Otakar Ahne'
  },
  {
    videoId: 'ydhqK4QtHYA',
    title: 'Globálni e-commerce a světová tržiště',
    author: 'Adam Kurzok'
  },
  {
    videoId: 'VUYfT82s3TI',
    title: 'Jak SE Odnaučit spouštět weby bez SEO kontroly',
    author: 'Pavel Ungr'
  },
  {
    videoId: 'MV5wukgrG5g',
    title: 'Obchodní plánování e-shopů',
    author: 'Pavel Hrstka'
  },
  {
    videoId: 'QvVy17N2EP4',
    title: 'Vylepšete si vztah se zákazníky pomocí mobilní aplikace',
    author: 'Václav Kos'
  },
  {
    videoId: 'KxSgv32-6JI',
    title: 'Case-study: Jak automatizovat expedici?',
    author: 'Martin Šauer'
  },
  {
    videoId: '4IgETlrcKOE',
    title: '10 tipů jak uspět s dynamickým remarketingem na Facebooku',
    author: 'Lukáš Krejča'
  },
  {
    videoId: '1YAPFA0Uhnk',
    title: 'Jak si udělat pořádek na podpoře',
    author: 'Mario Roženský'
  },
  {
    videoId: 'd2g1hCpiaDU',
    title: 'Case-study: Jak zrychlit nákupní rozhodnutí a nenechat zákazníka odejít ke konkurenci',
    author: 'Petr Kováčik'
  },
  {
    videoId: 'uQj5fcQbYaI',
    title: '10 tipů, jak může e-shop budovat svou značku',
    author: 'Matez Jindra'
  },
  {
    videoId: 'sr_Em1XNsa8',
    title: 'Inovace a novinky na českých i zahraničních eshopech',
    author: 'Jan Kvasnička'
  },
  {
    videoId: 'rFMJVWYvH7I',
    title: 'E-commerce trendy roku 2016',
    author: 'Tomáš Braverman'
  },
]

const data2015 = [
  {
    videoId: 'SQjn30GbIEY',
    title: 'Potenciál e-commerce v ČR z pohledu kategorií zboží',
    author: 'Tomáš Braverman'
  },
  {
    videoId: '464A8WuGMc0',
    title: 'Co zbyde obchodům z marketingu, když škrtnou veškerou reklamu',
    author: 'Marek Prokop'
  },
  {
    videoId: 'LTbacA_koAs',
    title: 'Pojďte naproti výkonu PPC kampaní',
    author: 'Jana Nádvorníková'
  },
  {
    videoId: '8PA-o-bxPYg',
    title: 'Jak dělat Facebook reklamu lépe, než ostatní',
    author: 'Eliška Vyhnánková'
  },
  {
    videoId: 'zIdymi_NyJg',
    title: 'Personalizace, velká zbraň, která se může otočit proti vám',
    author: 'Jan Kvasnička'
  },
  {
    videoId: 'pzuqGwFIG8A',
    title: 'Zákulisní info o tom, jak přemýšlí investoři',
    author: 'Ondřej Tomek'
  },
  {
    videoId: '4avww0wT2Ug',
    title: 'Jak na strukturu webu z pohledu SEO',
    author: 'Pavel Ungr'
  },
  {
    videoId: 'OL5ah5AxXkM',
    title: 'Právní přešlapy v onlinu',
    author: 'Lucie Radkovičová'
  },
  {
    videoId: 'yp--DdZpvD0',
    title: 'E-shop není jen web',
    author: 'Jan Tichý'
  },
  {
    videoId: 'COeK8XDMahc',
    title: 'Jak jsem poznal Shoptet a ShopSys',
    author: 'Karel Novotný'
  },
  {
    videoId: '7dcD1sGjtYM',
    title: '7 tipů jak navýšit tržby e-shopu před Vánoci 2015',
    author: 'Michal Janík'
  },
  {
    videoId: '89uAEjZEBpE',
    title: 'Připravte své PPC kampaně na Vánoce',
    author: 'Petra Mašková'
  },
  {
    videoId: 'uVdyOOiWB0g',
    title: 'Rychlejší práce v Skliku pro e-shopy',
    author: 'Petr Pavelek'
  },
  {
    videoId: 'kzYslvNsg3o',
    title: 'Co se za poslední rok změnilo v největších e-shopech v ČR',
    author: 'Lukáš Hurych'
  },
  {
    videoId: 'qDsLBodKREk',
    title: 'Proč není nejdůležitějším členem marketingu člověk, ale automat?',
    author: 'David Beška'
  },
]

const data2014 = [
  {
    videoId: '7-5vAc4fSLg',
    title: 'Jak zdvojnásobit obrat eshopu za pouhé čtyři měsíce',
    author: 'Michal Kubíček'
  },
  {
    videoId: 'A95KFWrDMlU',
    title: 'Nebuďte s analýzou dat 100 let za opicema!',
    author: 'Jan Laštůvka'
  },
  {
    videoId: 'F58_A5TM-Sc',
    title: 'Jak to nepo­…kazit v cílové rovince',
    author: 'David Grudl'
  },
  {
    videoId: 'QD7PMNB2eiY',
    title: '10 najčastejších chýb e-shopov',
    author: 'Michal Král'
  },
  {
    videoId: '_i3kgOIDUtY',
    title: 'Jak přemýšlet nad obsahem e-shopu',
    author: 'Jan Řezáč'
  },
  {
    videoId: 'mJpCVPJZ8q0',
    title: 'Optimalizace objednávkového procesu',
    author: 'Jan Kvasnička'
  },
  {
    videoId: 'zP1_gylnq2U',
    title: 'STOP mass mailům! Nastartujme inteligentní emailing',
    author: 'Jan Penkala'
  },
  {
    videoId: 'HC2HjE_Pz10',
    title: 'User-centric analytics',
    author: 'Jan Tichý'
  },
  {
    videoId: 'ii1NQDXCoxc',
    title: 'Díra v nákupním procesu – návod “co nedělat”',
    author: 'Lukáš Hurych'
  },
]

export default {
  components: {
    Carousel,
    CarouselItem,
    Dropdown,
  },

  setup() {
    const { width } = useWindowSize();

    const shadowHeight = computed(() => {
      if(width.value < 800) {
        return 156;
      }

      return 225;
    });

    return {
      shadowHeight
    }
  },

  data() {
    return {
      selectedYear: 2024
    }
  },

  methods: {
    changeSelectedYear(selectedYear) {
      this.selectedYear = selectedYear;
    },
  },

  computed: {
    currentYearData() {
      if (this.selectedYear === 2024) {
        return data2024;
      }

      if (this.selectedYear === 2023) {
        return data2023;
      }

      if (this.selectedYear === 2022) {
        return data2022;
      }

      if (this.selectedYear === 2021) {
        return data2021;
      }

      if (this.selectedYear === 2020) {
        return data2020;
      }

      if (this.selectedYear === 2019) {
        return data2019;
      }

      if (this.selectedYear === 2018) {
        return data2018;
      }

      if (this.selectedYear === 2017) {
        return data2017;
      }

      if (this.selectedYear === 2016) {
        return data2016;
      }

      if (this.selectedYear === 2015) {
        return data2015;
      }

      if (this.selectedYear === 2014) {
        return data2014;
      }
    }
  }
};
</script>

<style>
</style>
